<template>
  <a-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('platformCollection.close')"
    wrapClassName="ant-modal-cust-warp"
    style="top: 5%; overflow-y: hidden"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('platformCollection.role_name')">
          <a-input
            :placeholder="$t('platformCollection.please_enter_role_name')"
            v-decorator="['roleName', validatorRules.roleName]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('platformCollection.role_name_en')">
          <a-input
            :placeholder="$t('platformCollection.please_enter_role_name_en')"
            v-decorator="['roleNameEn', validatorRules.roleName]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('platformCollection.role_type')">
          <a-radio-group v-decorator="['type', { initialValue: '1' }]">
            <a-radio value="1">{{ $t('platformCollection.system_role') }}</a-radio>
            <a-radio value="2">{{ $t('platformCollection.application_role') }}</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('platformCollection.role_code')">
          <a-input
            :placeholder="$t('platformCollection.please_enter_role_code')"
            :disabled="roleDisabled"
            v-decorator="['roleCode', validatorRules.roleCode]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('platformCollection.role_description')">
          <a-textarea
            :rows="5"
            :placeholder="$t('platformCollection.please_enter')"
            v-decorator="['roleDesc', validatorRules.roleDesc]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'

export default {
  name: 'RoleModal',
  data() {
    return {
      title: '',
      visible: false,
      roleDisabled: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        roleName: {
          rules: [{ required: true, message: this.$t('platformCollection.please_enter_role_name_required') }],
        },
        roleNameEn: {
          rules: [{ required: true, message: this.$t('platformCollection.please_enter_role_name_en_required') }],
        },
        roleCode: {
          rules: [{ required: true, message: this.$t('platformCollection.please_enter_role_code_required') }],
        },
        roleDesc: {
          rules: [],
        },
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.open()
      console.log(1111, pick(record, 'roleName', 'roleNameEn', 'type', 'roleCode', 'roleDesc', 'roleCode'))
      const data = pick(record, 'roleName', 'roleNameEn', 'type', 'roleCode', 'roleDesc')
      this.model = {
        ...this.model,
        ...data,
        type: data.type != undefined ? '' + data.type : '1',
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(this.model)
      })
    },
    open() {
      this.visible = true
      this.title = this.$t('platformCollection.operation')
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    openLoading() {
      this.confirmLoading = true
    },
    closeLoading() {
      this.confirmLoading = false
    },
    handleOk() {
      console.log(88888)
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = {
            ...values,
          }
          this.$emit('ok', formData)
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateRoleCode(rule, value, callback) {
      if (/[a-zA-Z]/g.test(value)) {
        callback('Role code cannot contain English characters!')
      } else {
        var params = {
          tableName: 'sys_role',
          fieldName: 'role_code',
          fieldVal: value,
          dataId: this.model.id,
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      }
    },
  },
}
</script>

<style scoped></style>
